import { SiteAbbreviation, SiteAlias, SiteName } from '../webshop-package'

export const siteAbbreviationToAliasMap: Record<SiteAbbreviation, SiteAlias> = {
  nvb: 'nationalevacaturebank',
  iol: 'intermediair',
  itb: 'itbanen',
}

export const siteAbbreviationToSiteAlias = (sites: SiteAbbreviation[]): SiteAlias[] =>
  sites.map(site => siteAbbreviationToAliasMap[site])

export const siteAliasToSiteName = (sites: SiteAlias[]): SiteName[] =>
  sites.map(site => siteAliasMap.get(site))

export const siteAliasMap: Map<SiteAlias, SiteName> = new Map([
  ['nationalevacaturebank', 'Nationale Vacaturebank'],
  ['intermediair', 'Intermediair'],
  ['itbanen', 'Tweakers Carrière'],
])

export const siteAbbreviationMap: Map<SiteAbbreviation, SiteName> = new Map([
  ['nvb', 'Nationale Vacaturebank'],
  ['iol', 'Intermediair'],
  ['itb', 'Tweakers Carrière'],
])

export const siteAbbreviationByAlias = (alias: SiteAlias): string | typeof undefined => {
  const name = siteAliasMap.get(alias)
  const abbreviation = Array.from(siteAbbreviationMap.keys()).find(key => siteAbbreviationMap.get(key) === name)
  return abbreviation
}

export const siteName = (alias: SiteAlias): string => siteAliasMap.get(alias) || alias
